<div id="socialLoginForm" class="login-container">
  <!-- Partículas de fondo animadas -->
  <div class="particle" *ngFor="let p of particles" [ngStyle]="{
    'left': p.left,
    'top': p.top,
    'width': p.size,
    'height': p.size,
    'animation-delay': p.delay
  }"></div>

  <!-- Tarjeta de login -->
  <mat-card class="login-card dashboard-card">
    <!-- Encabezado con imagen (más grande como antes) -->
    <img mat-card-image src="https://w3miglm.blob.core.windows.net/com/wwwInternals/Login/login_card.webp"
      alt="Encabezado login" class="card-header-image">

    <!-- Botón principal de MiGLM -->
    <div class="login-main-button">
      <button mat-raised-button color="primary" (click)="externalLogin()" class="glm-login-button">
        <div class="glm-button-content">
          <img src="https://w3miglm.blob.core.windows.net/com/wwwInternals/Logo%20GLM/logo_color_simbol.png"
            alt="Logo GLM" class="glm-logo">
          <h2 class="glm-button-text">MiGLM</h2>
        </div>
      </button>
    </div>

    <!-- Mensaje de error -->
    <ng-container *ngIf="error">
      <mat-error class="error-message">{{error.error}}</mat-error>
    </ng-container>

    <!-- Formulario de login -->
    <mat-card-content class="card-content">
      <form [formGroup]="loginForm" (submit)="onSubmit()">
        <!-- Campo email -->
        <mat-form-field appearance="outline" class="full-width-form-field">
          <mat-label>Escriba su correo registrado</mat-label>
          <input type="email" matInput formControlName="email" required autocomplete="email">
          <mat-icon matSuffix>email</mat-icon>
          <mat-error *ngIf="f.email.errors?.required" i18n="@@campoObligatorio">
            Campo obligatorio
          </mat-error>
          <mat-error *ngIf="f.email.errors?.email" i18n="@@errorCorreo">
            Error en el correo
          </mat-error>
        </mat-form-field>

        <!-- Campo contraseña -->
        <div *ngIf="isGlmMail()">
          <mat-form-field appearance="outline" class="full-width-form-field">
            <mat-label>Contraseña</mat-label>
            <input type="password" matInput formControlName="password" required autocomplete="current-password">
            <mat-icon matSuffix>lock</mat-icon>
            <mat-error *ngIf="f.password.errors?.required" i18n="@@campoObligatorio">
              Campo obligatorio
            </mat-error>
          </mat-form-field>

          <!-- Botón de submit -->
          <div class="submit-button">
            <button *ngIf="!loading; else progress" mat-raised-button color="primary" type="submit" class="login-button"
              i18n="@@ingresar">
              <mat-icon>login</mat-icon>
              Ingresar
            </button>
            <ng-template #progress>
              <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
            </ng-template>
          </div>
        </div>
      </form>


      <!-- Enlaces de ayuda - Versión corregida -->
      <div *ngIf="isGlmMail()" class="help-links-container">
        <!-- NUEVO RESET COMENTADO -->
        <!-- <a (click)="goToResetPassword()" class="help-link-card"> --> 
        <a href="https://mi.glm.edu.co/Account/Forgot" class="help-link-card">
          <mat-icon class="help-icon">vpn_key</mat-icon>
          <div class="help-text">
            <h4 class="help-title">Restablecer contraseña</h4>
            <p class="help-description">Recupere su acceso aquí</p>
          </div>
          <mat-icon class="help-arrow">chevron_right</mat-icon>
        </a>

        <a class="help-link-card" (click)="showInfo = !showInfo">
          <mat-icon class="help-icon">person_add</mat-icon>
          <div class="help-text">
            <h4 class="help-title">¿Es un usuario nuevo?</h4>
            <p class="help-description">Obtenga información para registrarse</p>
          </div>
          <mat-icon class="help-arrow">chevron_right</mat-icon>
        </a>

      </div>

      <!-- Información adicional -->
      <div class="info-card" *ngIf="showInfo">
        <div class="info-header">
          <mat-icon class="info-icon">info</mat-icon>
          <h4 class="info-title">Ayuda para nuevos usuarios</h4>
        </div>
        <p class="info-content">
          Si no conoce su usuario o no tiene un correo registrado, por favor escriba a
          <a href="mailto:soporte@glm.edu.co" class="info-link">soporte&#64;glm.edu.co</a>
        </p>
      </div>

      <mat-divider class="custom-divider"></mat-divider>

      <!-- Botón alternativo -->
      <div class="alternative-login">
        <button mat-raised-button color="primary" (click)="externalLogin()" i18n="@@ingresarCorreoGlm">
          <mat-icon>alternate_email</mat-icon>
          Ingresar con su correo GLM
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>